import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CityInfoModel } from '@digilize/shared/definitions/src';
import { BehaviorSubject, catchError, map, Observable, of, shareReplay, tap } from 'rxjs';

interface CitiesResponse {
  data: CityInfoModel[];
  records_total: number;
  records_filtered: number;
  draw: number;
}

@Injectable({ providedIn: 'root' })
export class CitiesApiService {
  private readonly http = inject(HttpClient);
  private readonly cities$$ = new BehaviorSubject<string[] | null>(null);
  private inflight$: Observable<string[]> | null = null;

  getCities(): Observable<string[]> {
    const cached = this.cities$$.value;
    if (cached) {
      return of(cached);
    }
    if (this.inflight$) {
      return this.inflight$;
    }
    this.inflight$ = this.http
      .get<CitiesResponse>('/api/v1.0/cities', { params: { length: 0 } })
      .pipe(
        map((res) => (res.data ?? []).map((c) => c.name)),
        tap((names) => this.cities$$.next(names)),
        catchError(() => {
          this.inflight$ = null;
          return of([] as string[]);
        }),
        shareReplay(1)
      );
    return this.inflight$;
  }
}
